<template>
  <form @submit.prevent="save">
    <v-card>
      <v-toolbar flat color="primary">
        <v-toolbar-title>Team Mitglieder</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        Alle Mitglieder dieses Teams verwalten
      </v-card-text>
      <v-card-text v-if="members">
        <v-list>
          <v-list-item
            v-for="member in members"
            :key="member.id"
            two-line
          >
            <v-list-item-avatar>
              <v-img :src="member.profile_photo_url" aspect-ratio="1" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ member.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ displayableRole(member.membership.role) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <MemberPermissions v-if="permissions.canRemoveTeamMembers" :team="team" :available-roles="availableRoles" :member="member">
                Permissions
              </MemberPermissions>
              <v-btn v-if="permissions.canRemoveTeamMembers" @click="remove(member)">
                Remove
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </form>
</template>

<script>
import MemberPermissions from '@/Components/Teams/MemberPermissions'
export default {
   components: {
      MemberPermissions
   },
   props: {
      team: {
         type: Object,
         required: true
      },
      members: {
         type: Array,
         required: true,
      },
      availableRoles: {
         type: Array,
         required: true,
      },
      permissions: {
         type: Object,
         required: true
      },
   },
   data () {
      return {
         form: this.$inertia.form(
            {
               email: '',
               role: null,
            }
         ),
      }
   },
   created () {},
   methods: {
      save () {
         this.form.put(this.route('teams.update', this.team), {
            preserveScroll: true,
         })
      },
      displayableRole (role) {
         return this.availableRoles.find(r => r.key === role).name
      },
      remove (member) {
         this.form.delete(this.route('team-members.destroy', { team: this.team, user: member }), {
            preserveScroll: true,
         })
      },
   },
}
</script>

<style>
</style>
